import { isNativeApp } from '@/utils/deviceUtils';

const MOBILE_MESSAGES_NAME = {
  PAGE_MOUNTED: 'pageMounted',
  LOGOUT: 'logout',
  REQUEST_PUSH_NOTIFICATION_PERMISSION: 'requestPushNotificationPermission',
  REQUEST_PUSH_NOTIFICATION_SETTINGS: 'requestPushNotificationSettings',
  CHECK_PUSH_NOTIFICATION_PERMISSION: 'checkPushNotificationPermission',
  SHARE_IMAGE: 'shareImage',
  SHARE_LINK: 'shareLink',
  DOWNLOAD_IMAGE: 'downloadImage',
  DOWNLOAD_CSV: 'downloadCsv',
  IN_APP_SUBSCRIPTION: 'inAppSubscription',
  CANCEL_SUBSCRIPTION: 'cancelSubscription',
  APPLY_SUBSCRIPTION_PROMOTION: 'applySubscriptionPromotion',
  BACK_NAVIGATION: 'backNavigation',
  ANALYTICS_EVENT: 'analyticsEvent',
};

const INCOME_MOBILE_MESSAGES_NAME = {
  SUBSCRIPTION_PURCHASE_RESULT: 'subscriptionPurchaseResult',
  CLOSE_POPUP: 'closePopup',
  APPLE_SUBSCRIPTION_MANAGEMENT_CLOSED: 'appleSubscriptionManagementClosed',
  SUBSCRIPTION_PROMOTION_RESULT: 'subscriptionPromotionResult',
  PUSH_NOTIFICATION_PERMISSION_STATUS: 'pushNotificationPermissionStatus',
  PUSH_TOKENS_REGISTERED: 'pushTokensRegistered',
};

function dispatchMessageToMobile(name, detail) {
  if (isNativeApp()) {
    window.dispatchEvent(new CustomEvent(
      name,
      { detail },
    ));
  }
}

function addListenerToMobileMessage(name, onResult) {
  window.addEventListener(name, e => {
    onResult(e.detail);
  });
}

function sendAnalyticsEventToMobile(eventName, properties = {}) {
  dispatchMessageToMobile(MOBILE_MESSAGES_NAME.ANALYTICS_EVENT, {
    eventName,
    properties,
  });
}

export default { dispatchMessageToMobile, addListenerToMobileMessage, sendAnalyticsEventToMobile, MOBILE_MESSAGES_NAME, INCOME_MOBILE_MESSAGES_NAME };
